module.exports = __webpack_public_path__ + "img/21.e7ba3868.jpg";